import { ReduxService } from 'dashboard-services/services';

import { pipelinesListDataScienceActions } from 'actions/modules/datascience';

export const basicInitialState = {
  selectedPipeline: undefined,
  isEditOpen: false,
  isPipelineShareOpen: false,
}

export default (state = basicInitialState, action) => {
  switch (action.type) {
    case pipelinesListDataScienceActions.ON_CHANGE: 
      if(state[action.name] !== action.value) {
        return ReduxService.updateObject(state, { [action.name]: action.value })
      }
      return state;
    default:
      return state;
  }
}